import Vue from 'vue';
import {
  LIST,
  STATUS
} from './mutation-types';

const metaFields = ['compnayNm','rmsDamdang','companySeq','year']

// 계약서 데이터 정리
// metadatas -> property
// 참가자의 서명여부 
const documentRemake = ( items ) => {

  items.forEach( item => {

    item.metadatas.forEach( meta => item[meta.key] = meta.value )

    // 참여자 정보에 서명여부 병합
    item.signings.forEach( sign => {

      const partic = item.participants.find( partic => sign.participantId == partic.id )
      if(partic) {
        partic.signed = true
        partic.signedAt = sign.signedAt
      }

    })

  })
  console.log(items)
  return items

}


export default {

  [LIST](state, response) {
    state.total = response.data.count;
    state.contracts = documentRemake( response.data.documents );
  },
  [STATUS](state, response) {
    console.log(state, response)
    state.statusInfo.map( item => {
      const find = response.status.find( info => item.meta === Object.keys(info)[0] )
      item.value = ( find || { [item.meta]: 0} )[item.meta]
    })

  }

};
